<template>
  <el-dialog v-dialog-drag='{width: "80vw", height: "90vh", marginTop: "5vh", isFullscreen: false}'
             :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='1400px'>
    <el-form v-loading='dialogLoading' :model='form' label-width='80px' label-position='right'
             ref='ruleForm' class='settlement-form mt20' :inline='true'>
      <el-form-item v-if='!getStatus' label=''>
        <el-radio-group size='mini' v-model='type' @input='clearYears'
                        :disabled='form.dataListMap.length !== 0'>
          <el-radio-button label='年'></el-radio-button>
          <el-radio-button label='月'></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if='!getStatus' :label='type + "："'>
        <el-date-picker
          v-model='years'
          :type='type === "年" ? "year" :"month"'
          :value-format='type === "年" ? "yyyy" : "yyyyMM"'
          :disabled='form.dataListMap.length !== 0'
          size='mini'
          placeholder='请选择年月'>
        </el-date-picker>
        <!--        <el-input v-model='years' size='mini' placeholder='请输入年月'/>-->
        <el-button size='small' class='searchBtn ml10' @click='newLine'>新增行
        </el-button>
      </el-form-item>
      <el-row v-else-if='dialogTitle === "详情"'>
        <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
          <span @click='exportData'>导出数据</span>
        </el-col>
      </el-row>

      <el-table
        ref='registerTable'
        v-loading='tableLoading'
        :data='form.dataListMap'
        max-height='640'
        style='width: 100%'
        row-key='id'
        border
        :header-cell-style='headerCellStyle'
      >
        <el-table-column label='按航线分-计划运量' align='center' fixed
                         :min-width='getStatus ? "480" : "400"'>
          <el-table-column prop='years' label='年月' align='center' min-width='80' fixed />
          <el-table-column prop='route' label='航线' align='center' min-width='160' fixed>
            <template slot-scope='scope'>
              <el-form-item v-if='dialogTitle === "新增" || dialogTitle === "修改"' label-width='0px'>
                <el-select
                  style='width: 100%;'
                  v-model='scope.row.route'
                  filterable
                  clearable
                  placeholder='请选择航线'
                  size='mini'
                  @change='routeChange(scope.row.route,scope.$index)'
                >
                  <el-option v-for='item in routeOptions' :label='item.route' :value='item.route'
                             :key='item.id' />
                </el-select>
              </el-form-item>
              <span v-else> {{ scope.row.route }}</span>
            </template>
          </el-table-column>
          <el-table-column prop='course' label='航向' align='center' min-width='80' fixed />
          <el-table-column v-if='!getStatus' prop='total' width="180px" :formatter='totalTotal' label='数量'
                           align='center' min-width='80' fixed />
          <el-table-column v-else prop='total' width="180" label='数量' align='center'
                           min-width='80' fixed />
          <el-table-column v-if='getStatus' prop='price'
                           label='金额' align='center' width="180" min-width='80' fixed />
        </el-table-column>
        <el-table-column label='按品牌分-计划运量' align='center'>
          <template v-if='getStatus'>
            <el-table-column align='center' v-for='index in Object.keys(form.brandList).length'
                             min-width='180'
                             :label='index.toString()'>
              <el-table-column align='center' min-width='180'>
                <template slot='header' slot-scope='scope'>
                  <span>{{ getBrand(form.brandList[`brandNumber${index}`]) }}</span>
                </template>
                <el-table-column label='ms船' width="180px" :prop='`msNumber${index}`' align='center' />
                <el-table-column v-if='flag' label='非ms船' width="180" :prop='`faultMsNumber${index}`'
                                 align='center' />
                <el-table-column v-if='flag' label='合计' width="180" :prop='`brandNumber${index}`'
                                 align='center' />
                <!--                <template slot-scope='scope'>-->
                <!--                  <span> {{ scope.row[`brandNumber${index}`] }}</span>-->
                <!--                </template>-->
              </el-table-column>
              <el-table-column label='委托商' align='center' min-width='180'>
                <template slot-scope='scope'>
                  <span>{{ getSupplier(form.supplierList[`supplierId${index}`]) }}</span>
                </template>
              </el-table-column>
              <el-table-column align='center' min-width='180'>
                <template slot='header' slot-scope='scope'>
                  {{ getBrand(form.brandList[`brandNumber${index}`]) === '' ? '' : '单价' }}
                </template>
                <template slot-scope='scope'>
                  <span>{{ scope.row[`unitPrice${index}`] }}</span>
                </template>
              </el-table-column>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column align='center' v-for='index in brandOptions.length' min-width='180'
                             :label='index.toString()'>
              <el-table-column align='center' min-width='200'>
                <template slot='header' slot-scope='scope'>
                  <el-select
                    v-model='form.brandList[`brandNumber${index}`]'
                    filterable
                    clearable
                    placeholder='请选择品牌'
                    size='mini'
                  >
                    <el-option v-for='item in brandOptions'
                               :label='item.brandName'
                               :value='item.brandId'
                               :key='item.brandId' />
                  </el-select>
                  <el-select
                    style='margin-top: 5px;'
                    v-model='form.supplierList[`supplierId${index}`]'
                    filterable
                    clearable
                    placeholder='请选择委托商'
                    size='mini'
                  >
                    <el-option v-for='item in supplierOptions'
                               :label='item.supplier'
                               :value='item.supplierId'
                               :key='item.supplierId' />
                  </el-select>
                </template>
                <el-table-column label='ms船' align='center'>
                  <template slot-scope='scope'>
                    <el-form-item label-width='0px'>
                      <el-input size='small' type='number'
                                v-model='scope.row[`msNumber${index}`]'
                                :disabled='!form.brandList[`brandNumber${index}`]' />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label='非ms船' align='center'>
                  <template slot-scope='scope'>
                    <el-form-item label-width='0px'>
                      <el-input size='small' type='number'
                                v-model='scope.row[`faultMsNumber${index}`]'
                                :disabled='!form.brandList[`brandNumber${index}`]' />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label='合计' align='center'>
                  <template slot-scope='scope'>
                    <el-form-item label-width='0px'>
                      {{ calculateBrandNumber(scope.$index, index) }}
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </template>
        </el-table-column>
        <el-table-column prop='remarks' label='备注' align='center' min-width='180px'>
          <template slot-scope='scope'>
            <el-form-item v-if='dialogTitle === "新增" || dialogTitle === "修改"' label-width='0px'
                          :prop='`dataListMap[${scope.$index}].remarks`'>
              <el-input size='small' v-model='scope.row.remarks' />
            </el-form-item>
            <span v-else> {{ scope.row.remarks }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if='!getStatus' label='操作' width='100' align='center' fixed='right'>
          <template slot-scope='scope'>
            <el-button size='mini' type='primary' @click='rowDelete("info",scope.$index)'>删除
            </el-button>
          </template>
        </el-table-column>
        <el-table-column v-else prop='taxRate' label='上下水占比' align='center' min-width='180px'
                         fixed='right' />
      </el-table>

      <div class='operation' v-if='this.dialogTitle === "详情"'>
        <div class='operationTitle'>
          <div class='line' />
          <span>操作信息</span>
        </div>
        <div class='operationTable'>
          <el-table
            row-key='id'
            :data='operateRecords'
            border
            :header-cell-style='headerCellStyle'>
            <el-table-column prop='createTime' label='操作时间' align='center' />
            <el-table-column prop='operateType' label='操作类型' align='center' />
            <el-table-column prop='operationName' label='操作人' align='center' />
            <el-table-column prop='remark' label='备注' align='center' />
          </el-table>
        </div>
      </div>

      <div class='flex-center-center mt10 mb20'
           v-if='dialogTitle === "修改" || dialogTitle === "新增" || dialogTitle === "审核"'>
        <el-button v-if='dialogTitle === "新增"|| dialogTitle === "修改"' size='medium'
                   class='searchBtn'
                   :loading='submitLoading' @click='submit(0)'>保存
        </el-button>
        <el-button v-if='dialogTitle === "审核"' size='medium' class='searchBtn'
                   :loading='submitLoading' @click='audit'>审核
        </el-button>
        <el-button size='medium' class='searchBtn'
                   :loading='submitLoading' @click='submit(1)'>提交
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import {
    brandQuery,
    commercialCarPlanAdd, commercialCarPlanAudit,
    commercialCarPlanDetails,
    commercialCarPlanUpdate,
  } from '@/service/financial';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    name: 'commercialCarPlanForm',
    data() {
      return {
        type: '年',
        dialogTitle: '',
        dialogLoading: false,
        dialogVisible: false,
        defaultForm: {},
        form: {
          brandList: {},
          supplierList: {},
          dataListMap: [],
          auditStatus: '',
        },
        operateRecords: [],
        years: '',
        brandOptions: [],
        supplierOptions: [],
        routeOptions: [],
        submitLoading: false,
        tableLoading: false,
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        flag: false, // true：商品车计划 false：轮船结算
      };
    },
    mounted() {
      console.log(this.$route.fullPath);
      this.flag = this.$route.fullPath === '/vehicle/commercialCarPlan';
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      calculateBrandNumber(rowIndex, colIndex) {
        return this.form.dataListMap[rowIndex][`brandNumber${colIndex}`] = (Number(this.form.dataListMap[rowIndex][`msNumber${colIndex}`]) || 0) + (Number(this.form.dataListMap[rowIndex][`faultMsNumber${colIndex}`]) || 0);
      },
      totalTotal(row, column, cellValue, index) {
        let count = 0;
        for (let i = 1; i < this.brandOptions.length + 1; i++) {
          if (row[`brandNumber${i}`]) count += Number(row[`brandNumber${i}`]);
        }
        this.form.dataListMap[index].total = count;
        return count;
      },
      dialogOpen(title, id) {
        this.dialogTitle = title;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.getSelectedData();
        if (id) this.getDetails(id);
        this.dialogVisible = true;
      },
      async getDetails(id) {
        this.form.id = id;
        this.dialogLoading = true;
        const {
          status,
          message,
          data,
        } = await commercialCarPlanDetails({
          id,
          type: this.dialogTitle === '详情' || this.dialogTitle === '审核' ? 0 : 1,
          flag:this.flag? 0 : 1,
        });
        this.dialogLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.form.dataListMap = data.valueList;
        this.form.brandList = data.titleSort;
        this.form.supplierList = data.supplierList;
        this.operateRecords = data.operateRecords;
        this.years = this.form.dataListMap && this.form.dataListMap [0] ? this.form.dataListMap[0].years : '';
        this.years.length === 6 ? this.type = '月' : this.type = '年';
      },
      dialogClose() {
        this.dialogVisible = false;
        this.years = '';
      },
      newLine() {
        if (this.years === null || this.years.length === 0) return this.$message.warning('请选择年月后生成行！');
        this.form.dataListMap.push({ years: this.years });
      },
      async getSelectedData() {
        this.dialogLoading = true;
        const {
          status,
          message,
          data: {
            routeList,
            brandList,
            supplierList,
          },
        } = await brandQuery();
        this.dialogLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.routeOptions = routeList;
        this.brandOptions = brandList;
        this.supplierOptions = supplierList;
      },
      routeChange(route, index) {
        this.form.dataListMap[index].course = this.routeOptions.find(item => item.route === route).course;
      },
      submit(type) {
        this.form.auditStatus = type;
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            let res = {};
            if (this.dialogTitle === '新增') {
              res = await commercialCarPlanAdd(this.form);
            } else {
              res = await commercialCarPlanUpdate(this.form);
            }
            if (res.status !== 0) return this.$message.warning(res.message);
            this.$message.success(res.message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        window.location.href = `${baseUrl}/platform/commercial/car/plan/export?access_token=${token}&id=${this.form.id}&flag=${this.flag?0:1}`;
      },
      audit() {
        this.$confirm('确认审核通过该条数据么！', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '拒绝',
          distinguishCancelAndClose: true,
          type: 'warning',
        })
          .then(async () => {
            const {
              status,
              message,
            } = await commercialCarPlanAudit({
              auditStatus: 2,
              id: this.form.id,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
          })
          .catch(async () => {
            const {
              status,
              message,
            } = await commercialCarPlanAudit({
              auditStatus: 3,
              id: this.form.id,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
          });
      },
      clearYears() {
        this.years = '';
      },
      rowDelete(index) {
        this.$confirm('确认删除当前行数据么！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.form.dataListMap.splice(index, 1);
          })
          .catch(() => {
          });
      },
      getBrand(id) {
        if (!id) return '';
        return this.brandOptions.find(item => item.brandId === id).brandName;
      },
      getSupplier(id) {
        if (!id) return '';
        return this.supplierOptions.find(item => item.supplierId === id).supplier;
      },
    },
    computed: {
      getStatus() {
        if (this.dialogTitle === '详情' || this.dialogTitle === '审核') return true;
        if (this.dialogTitle === '新增' || this.dialogTitle === '修改') return false;
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 95%;
    margin: 0 auto;
    overflow: hidden;
  }

  .el-input {
    width: 165px;
  }

  .operation {
    display: flex;
    flex-direction: column;

    &Title {
      display: flex;
      align-items: flex-end;

      p {
        font-weight: 700;
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        margin-left: 10px;
      }
    }

    &Table {
      width: 100%;
      margin-top: 10px;

      ::v-deep {
        .el-table td, .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }
    }
  }

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
    margin-top: 20px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  ::v-deep {
    .el-input--small {
      width: 65px;
    }
  }
</style>
